// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Mo-z","tupacHeader":"No-z","tupacHeader2":"Oo-z","tupacMenu":"Po-z","tupacMenu2":"Qo-z","tupacMain":"Ro-z","tupacMain2":"So-z"};